import logo from '../logo.png';

export default function CreatedBy() {
  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '20px',
      display: 'flex',
      alignItems: 'flex-end',
      gap: '6px',
    }}>
      <span style={{ fontSize: '9px', letterSpacing: '0.15em', color: '#B0A99F', textTransform: 'uppercase', transform: 'translateY(5px)' }}>
        Created by
      </span>
      <a href="https://andto.jp/" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', transform: 'translateY(4px)' }}>
        <img src={logo} alt="and to" style={{ width: '40px', display: 'block', opacity: 0.5, transition: 'opacity 0.2s' }}
          onMouseEnter={e => e.currentTarget.style.opacity = 1}
          onMouseLeave={e => e.currentTarget.style.opacity = 0.5}
        />
      </a>
    </div>
  );
}
